import { Stack, Tabs } from '@mantine/core';
import TabsList from '@repo/common/components/TabsList';
import { useState } from 'react';
import {
	useSuspenseFeatureAccess,
	type IIntegration,
} from '../../../../../api';
import { SyncType } from '../../../../../interfaces/Enums';
import type { IntegrationSpec } from '../../../../../interfaces/IntegrationSpec';
import { SyncTable } from './SyncTable';

interface SyncPanelProps {
	integration: IIntegration;
	spec: IntegrationSpec;
}

export function SyncPanel({ integration, spec }: SyncPanelProps) {
	const [activeTab, setActiveTab] = useState<string | null>(SyncType.PULL);
	const { secodaCoreAccess } = useSuspenseFeatureAccess();

	const renderContent = () => {
		if (spec.value.disablePullMetadata) {
			return <SyncTable integration={integration} type={SyncType.PUSH} />;
		} else if (spec.value.supportsPushMetadata) {
			return (
				<Tabs
					color="dark"
					defaultValue={SyncType.PULL}
					value={activeTab}
					onTabChange={setActiveTab}
				>
					<TabsList
						tabs={[
							{ value: SyncType.PULL, label: 'Pull' },
							...(secodaCoreAccess
								? [{ value: SyncType.PUSH, label: 'Push' }]
								: []),
						]}
					/>

					<Tabs.Panel value={SyncType.PULL} pt="2xl">
						<SyncTable integration={integration} type={SyncType.PULL} />
					</Tabs.Panel>

					<Tabs.Panel value={SyncType.PUSH} pt="2xl">
						<SyncTable integration={integration} type={SyncType.PUSH} />
					</Tabs.Panel>
				</Tabs>
			);
		}
		return <SyncTable integration={integration} type={SyncType.PULL} />;
	};

	return <Stack>{renderContent()}</Stack>;
}
